import { CarrierIntegrationMapper } from "./carrier-integration.mapper";
import { carrierProviders } from "./carrier-integration.model";
import { OrganizationLogoMapper } from "./organization-logo/organization-logo.mapper";
import { OrganizationTermsMapper } from "./organization-terms/organization-terms.mapper";
import { Organization } from "./organization.model";

export class OrganizationMapper {
  public static map(data: any): Organization {
    if (!data) {
      return null;
    }

    const organization = new Organization(
      data.id,
      data.name,
      OrganizationLogoMapper.map(data.logo),
      data.numberOfLicenses,
      data.createdAt ? new Date(data.createdAt) : null,
      data.modifiedAt ? new Date(data.modifiedAt) : null,
      data.activeTo ? new Date(data.activeTo) : null,
      data.statisticsRefreshedAt ? new Date(data.statisticsRefreshedAt) : null,
      data.nip,
      data.street,
      data.postalCode,
      data.city,
      data.country,
      data.emailAuthMode,
      data.emailEncryption,
      data.emailHost,
      data.emailImapHost,
      data.emailImapPort,
      data.emailImapSsl,
      data.emailPort,
      data.spread,
      data.quoteCollectingEmail,
      OrganizationTermsMapper.map(data.allTerms),
      data.currency,
      data.insuranceValueMultiplierPercent,
      data.insuranceRatePercent,
      data.insuranceMinValue,
      data.insuranceMinCurrency,
      data.ecuAccountId,
      data.showCarrier,
      data.showRateSurcharges,
      data.webCargoNetKey1,
      data.webCargoNetKey2,
      data.cmaBehalfOf,
      data.bluexUserApiKey,
      data.okargoToken,
      data.okargoCarriers,
      data.shipcoApiCustomerAlias,
      data.bank,
      data.dateFormat,
      data.pdfLayout,
      data.brandColor,
      data.modulesCrm,
    );
    organization.applyCredits(
      data.monthlyFreeCredits ?? 0,
      data.availableCredits ?? 0,
    );
    for (const provider of carrierProviders) {
      organization.applyCarrierIntegration(
        provider,
        CarrierIntegrationMapper.mapState(data.integrations?.[provider]),
      );
    }

    return organization;
  }
}
